import { useRecoilValueLoadable } from 'recoil';

import { UsersTable } from '../../../entities/users';
import { userState } from '../../../state/user';

export const UsersPage = () => {
  const currentUser = useRecoilValueLoadable(userState).valueMaybe();

  return currentUser ? <UsersTable /> : null;
};
